<template lang="pug">

</template>

<script>
  export default {
    name: "error-universal",
    data() {
      return {
        errors: [],
        toastTime: 5000,
        clearErrorsTimeout: null
      }
    },
    computed: {
      apiError() {
        return this.$store.getters.apiError
      },
      workspaceAndVersion() {
        return {
          version: this.$store.getters.version,
          workspace: this.$store.getters.workspace,
        }
      },
    },
    watch: {
      $route() {
        this.$store.commit('setApiError', null)
      },
      workspaceAndVersion() {
        this.$store.commit('setApiError', null)
      },
      apiError(newVal) {
        if(newVal) {
          this.errors.push(newVal.detail || newVal.error || newVal.info || newVal.message)
          this.showErrorToast()
        } else {
          this.errors = []
          this.$ui.toast.hide()
          clearTimeout(this.clearErrorsTimeout)
          this.clearErrorsTimeout = null
        }
      }
    },
    methods: {
      showErrorToast() {
        if(this.clearErrorsTimeout) {
          this.clearErrorsTimeout = null
          clearTimeout(this.clearErrorsTimeout)
        }
        this.$ui.toast.show({text: this.errors.map(v => '<p>' + v + '</p>').join(''), type: 'error', time: this.toastTime})
        this.clearErrorsTimeout = setTimeout(() => {
          this.errors = []
        }, this.toastTime)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ErrorUniversal.vue